angular.module('SpidApp', [
    'ui.router'
  , 'restangular'
  , 'ui.bootstrap'
  , 'ngStorage'
  , 'ngToast'
  , 'ngAnimate'
  , 'gettext'
  , 'chart.js'
])

.constant('BASE_PUBLIC_URL', gv_basepublic_app)

.constant('DATA_SERVER_CONFIG', {
    host: 'http://localhost',
    port: 10000,
    getURL: function () {
        return this.host + ':' + this.port;
    }
})

.constant('SPID_CONFIG', {
    synchro: {
        isEnabled: true,
        intervalMin :120000,
        intervalAuto :1800000
    },
    mocks: {
        products: {
            isMocked: false
        }
    },

    products: {
        barcodes: {
            type: 'EAN'
        }
    },
    devices: {
        areMocked: false, // override all 'isMocked' properties of devices (One mock to rule them all)
        scale: {
            isMocked: false,
            host: 'http://localhost',
            port: 10001
        },
        drawer: {
            isMocked: false,
            host: 'http://localhost',
            port: 10002
        },
        stickerPrinter: {
            isMocked: false,
            host: 'http://localhost',
            port: 10003
        },
        receiptPrinter: {
            isMocked: false,
            host: 'http://localhost',
            port: 10003
        }
    }
})

.config(['BASE_PUBLIC_URL', 'DATA_SERVER_CONFIG', '$stateProvider', '$urlRouterProvider', 'RestangularProvider', 'ToasterProvider', '$compileProvider', '$httpProvider', 'USER_CONFIG',
function (BASE_PUBLIC_URL,   DATA_SERVER_CONFIG,   $stateProvider,   $urlRouterProvider,   RestangularProvider,   ToasterProvider,   $compileProvider,   $httpProvider,   USER_CONFIG) {

            $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|data):/);

            RestangularProvider.setBaseUrl(DATA_SERVER_CONFIG.getURL());
            moment.locale('fr'); // set to french

            ToasterProvider.configure({
                verticalPosition: 'top',
                maxNumber: 4
            });

            RestangularProvider.setErrorInterceptor(function (response) {
                if (response.status === 401) {
                    console.error('Not logged in');
                }

                return response;
            });

            $urlRouterProvider.otherwise("/app");
            $stateProvider

            .state('team', {
                url: "/team",
                templateUrl: BASE_PUBLIC_URL + '/views/team.html',
                controller: 'TeamController'
            })

            .state('login', {
                url: "/login",
                templateUrl: BASE_PUBLIC_URL + '/views/login.html',
                controller: 'LoginController'
            })

            .state('logout', {
                url: "/logout",
                controller: 'LogoutController'
            })

            .state('resetpassword', {
                url: "/resetpassword",
                templateUrl: BASE_PUBLIC_URL + '/views/reset-password.html',
                controller: 'ResetPasswordController'
            })
            
            .state('app', {
                url: "/app",
                templateUrl: BASE_PUBLIC_URL + '/views/app.html',
                controller: 'AppController'
            })

            .state('app.operations', {
                url: "/operations",
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/operations.html',
                        controller: 'OperationsController'
                    }
                },
                params: {
                    roles: [USER_CONFIG.superviseur.roleName]
                }
            })

            .state('app.password', {
                url: "/password",
                templateUrl: BASE_PUBLIC_URL + '/views/password.html',
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/password.html',
                        controller: 'PasswordController'
                    }
                },
                params: {
                    roles: [USER_CONFIG.superviseur.roleName, USER_CONFIG.receveur.roleName, USER_CONFIG.guichetier.roleName]
                }
            })

            .state('app.vacation', {
                url: "/vacation/{id}",
                params: {
                    roles: [USER_CONFIG.receveur.roleName, USER_CONFIG.guichetier.roleName],
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/vacation-open.html',
                        controller: 'VacationController'
                    }
                }
            })

            .state('app.stocks', {
                url: "/agency/{agencyId}/stocks",
                params: {
                    roles: [USER_CONFIG.receveur.roleName, USER_CONFIG.superviseur.roleName],
                    agencyId: null
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/stocks.html',
                        controller: 'StocksController'
                    }
                }
            })

            .state('app.stocks.stockProducts', {
                url: "/stockProducts",
                templateUrl: BASE_PUBLIC_URL + '/views/stocksProducts.html'
            })

            .state('app.stocks.stockProductsOp', {
                url: "/stockProductsOp",
                templateUrl: BASE_PUBLIC_URL + '/views/stocksProductsOp.html'
            })
            
            .state('app.stocks.stockFlowsHistory', {
                url: "/stockFlowsHistory",
                templateUrl: BASE_PUBLIC_URL + '/views/stock-flows-history.html',
                params: {
                	historyAgencyId: null
                },
                controller: 'StockFlowsHistoryController'
            })

            .state('app.stockflows', {
                url: "/agency/{agencyId}/stocks/{stockId}/stockflows",
                params: {
                    roles: [USER_CONFIG.receveur.roleName],
                    agencyId: null,
                    stockId: null
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/stock-flows.html',
                        controller: 'StockFlowsController'
                    }
                }
            })

            .state('app.vacation-details', {
                url: "/vacation-details/{id:.+}",
                params: {
                    roles: [USER_CONFIG.receveur.roleName],
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/vacation-details.html',
                        controller: 'VacationDetailsController'
                    }
                }
            })

            .state('app.shop', {
                url: "/shop",
                params: {
                    roles: [USER_CONFIG.receveur.roleName, USER_CONFIG.guichetier.roleName],
                    checkInventory: true
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/shop.html',
                        controller: 'ShopController'
                    }
                }
            })

            .state('app.business-day', {
                url: "/business-day",
                params: {
                    roles: [USER_CONFIG.receveur.roleName],
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/business-day.html',
                        controller: 'BusinessDayController'
                    }
                }
            })

            .state('app.money-transfer', {
                url: "/money-transfer",
                params: {
                    roles: [USER_CONFIG.receveur.roleName],
                },
                views: {
                    'appContent': {
                        templateUrl: BASE_PUBLIC_URL + '/views/money-transfer.html',
                        controller: 'MoneyTransferController'
                    }
                }
            })



            .state('app.money-transfer-superviseur', {
                url: "/money-transfer-superviseur/history",
                params: {
                    roles: [USER_CONFIG.superviseur.roleName],
                },
                views: {
                    'appContent': {
                        templateUrl: BASE_PUBLIC_URL + '/views/money-transfer-superviseur.html',
                        controller: 'MoneyTransferSuperviseurController'
                    }
                }
            })

            .state('app.money-transfer.to', {
                url: "/to",
                templateUrl: BASE_PUBLIC_URL + '/views/money-transfer-to.html'
            })

            .state('app.money-transfer.from', {
                url: "/from",
                templateUrl: BASE_PUBLIC_URL + '/views/money-transfer-from.html'
            })

            .state('app.money-transfer.history', {
                url: "/history",
                templateUrl: BASE_PUBLIC_URL + '/views/money-transfer-history.html'
            })

            .state('app.tools', {
                url: "/tools",
                abstract: true,
                params: {
                    roles: [USER_CONFIG.receveur.roleName, USER_CONFIG.guichetier.roleName],
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/tools.html'
                    }
                }
            })

            .state('app.tools.barcodes', {
                url: "/barcodes",
                views: {
                    toolsContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/tools-barcodes.html',
                        controller: 'BarcodePrintingController'
                    }
                }
            })

            .state('app.parameters', {
                url: "/params",
                params: {
                    roles: [USER_CONFIG.receveur.roleName, USER_CONFIG.superviseur.roleName],
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/parameters.html',
                        controller: 'ParamsController'
                    }
                }
            })

            .state('app.parameters.agency', {
                url: "/agency",
                templateUrl: BASE_PUBLIC_URL + '/views/param-agency.html',
                controller: 'AgencyController'
            })

            .state('app.parameters.currency', {
                url: "/currency",
                templateUrl: BASE_PUBLIC_URL + '/views/param-currency.html',
                controller: 'CurrencyController'
            })

            .state('app.parameters.users', {
                url: "/users",
                templateUrl: BASE_PUBLIC_URL + '/views/param-users.html',
                controller: 'UserParamsController'
            })

            .state('app.test', {
                url: "/test",
                params: {
                    roles: [USER_CONFIG.superviseur.roleName],
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/test.html'
                    }
                }
            })

            .state('app.order', {
                url: "/order",
                params: {
                    roles: [USER_CONFIG.receveur.roleName, USER_CONFIG.guichetier.roleName],
                    checkInventory : false
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/order.html',
                        controller: 'OrderController'
                    }
                }
            })

            .state('app.order-edit', {
                url: "/order/{id}/{lot}/{agency}",
                params: {
                    roles: [USER_CONFIG.receveur.roleName, USER_CONFIG.guichetier.roleName],
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/order.html',
                        controller: 'OrderController'
                    }
                }
            })

            .state('app.orderlist', {
                url: "/order-list",
                params: {
                    roles: [USER_CONFIG.receveur.roleName, USER_CONFIG.guichetier.roleName],
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/order-list.html',
                        controller: 'OrderListController'
                    }
                }
            })

            .state('app.inventoryList', {
                url: "/agency/{agencyId}/inventory-list",
                params: {
                    roles: [USER_CONFIG.receveur.roleName],
                    agencyId: null
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/inventory-list.html',
                        controller: 'InventoryListController'
                    }
                }
            })

            .state('app.inventory-details', {
                url: "/agency/{agencyId}/inventory-details/{inventoryId}",
                params: {
                    roles: [USER_CONFIG.receveur.roleName],
                    agencyId: null
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/inventory-details.html',
                        controller: 'InventoryDetailController'
                    }
                }
            })

            .state('app.inventory', {
                url: "/agency/{agencyId}/user/{userId}/inventory",
                params: {
                    roles: [USER_CONFIG.guichetier.roleName],
                    agencyId: null,
                    userId: null
                },
                views: {
                    appContent: {
                        templateUrl: BASE_PUBLIC_URL + '/views/inventory.html',
                        controller: 'InventoryController'
                    }
                }
            })

            .state('app.inventory.products', {
                url: "/products",
                templateUrl: BASE_PUBLIC_URL + '/views/inventory-products.html'
            })

            .state('app.inventory.productsOp', {
                url: "/productsOp",
                templateUrl: BASE_PUBLIC_URL + '/views/inventory-productsOp.html'
            });

}])

.run(   ['Restangular', '$state', '$rootScope', 'LoginService', '$localStorage', 'ConfigService', '$interval', 'SyncRunner', 'SPID_CONFIG', 'gettextCatalog', 'BASE_PUBLIC_URL',
function (Restangular,   $state,   $rootScope,   LoginService,   $localStorage,   ConfigService,   $interval,   SyncRunner,   SPID_CONFIG,   gettextCatalog,   BASE_PUBLIC_URL) {

            var lang = 'fr_FR';
            gettextCatalog.setCurrentLanguage(lang);
            gettextCatalog.loadRemote(BASE_PUBLIC_URL + "/../dist/translations/" + lang + ".json");
            gettextCatalog.debug = false;

            $rootScope.$on('$stateChangeStart', function (event, toState) {
                var accessibleRoutes = [
                      'resetpassword'
                    , 'login'
                    , 'team'
                ];
                
                if (accessibleRoutes.lastIndexOf(toState.name) === -1 && !LoginService.isLoggedIn()) {
                    console.error('Intercepted, you should login');
                    event.preventDefault();
                    $state.go('login');
                    return;
                }

                if (!$localStorage.auth) {
                    return;
                }

                Restangular.setDefaultHeaders({
                    Authorization: $localStorage.auth.basic
                });
            })
}]);